import React from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
`;

const Card = styled.div`
  background: white;
  border-radius: 16px;
  padding: 40px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
`;

const Icon = styled.div`
  font-size: 64px;
  margin-bottom: 20px;
`;

const Title = styled.h1`
  color: #333;
  font-size: 28px;
  margin-bottom: 16px;
  font-weight: 600;
`;

const Message = styled.p`
  color: #666;
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 30px;
`;

const ContactInfo = styled.div`
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  margin-top: 20px;
  border-left: 4px solid #007AFF;
`;

const ContactTitle = styled.h3`
  color: #333;
  font-size: 18px;
  margin-bottom: 12px;
  font-weight: 600;
`;

const ContactText = styled.p`
  color: #666;
  font-size: 14px;
  margin-bottom: 0;
`;

const Button = styled.button`
  background: #007AFF;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s ease;
  
  &:hover {
    background: #0056b3;
  }
`;

const PropertyUnavailable = () => {
  const { propertyId } = useParams();

  const handleGoHome = () => {
    window.location.href = '/';
  };

  return (
    <Container>
      <Card>
        <Icon>🏠</Icon>
        <Title>Property No Longer Available</Title>
        <Message>
          This property is no longer available for showings because it has either been 
          <strong> unlisted, rented, or sold</strong>.
        </Message>
        
        <ContactInfo>
          <ContactTitle>Need More Information?</ContactTitle>
          <ContactText>
            Please contact the listing agent directly for details about this property's current status 
            or to inquire about similar available properties.
          </ContactText>
        </ContactInfo>
        
        <Button onClick={handleGoHome} style={{ marginTop: '20px' }}>
          🏡 Browse Other Properties
        </Button>
        
        <div style={{ 
          marginTop: '20px', 
          fontSize: '12px', 
          color: '#999',
          borderTop: '1px solid #eee',
          paddingTop: '15px'
        }}>
          Property ID: {propertyId}
        </div>
      </Card>
    </Container>
  );
};

export default PropertyUnavailable;